<template>
    <div class="w-100 bg-white">
        <div class="min-vh-100 bg-white border border-1 d-flex justify-content-center align-items-center">
            <h4 class="text-secondary size-18"><font-awesome-icon :icon="['fas', 'sync-alt']" class="me-1" /> Cargando ...</h4>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'loading-placeholder-dashboard',
        props: {
            type: {
                require: false,
            }
        }
    }
</script>